module.exports = __webpack_public_path__ + "img/directions_walk.c6c2b8fd.svg";